if (!customElements.get('eot-related-pages')) {
  customElements.define('eot-related-pages', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-paged-grid], .product-grid');
      this.items = this.grid ? Array.from(this.grid.children) : [];
      this.controls = this.querySelector('.eot-related-controls');
      this.status = this.querySelector('.eot-related-status');
      this.prev = this.querySelector('[data-page-prev]');
      this.next = this.querySelector('[data-page-next]');
      if (!this.items.length || !this.grid) return;
      this.page = 0;
      this.prev.onclick = () => this.showPage(this.page - 1);
      this.next.onclick = () => this.showPage(this.page + 1);
      this.observer = new ResizeObserver(() => {
        const size = Number(this.dataset.pageSize) || getComputedStyle(this.grid).gridTemplateColumns.split(' ').length;
        if (size !== this.pageSize) {
          const first = this.page * (this.pageSize || size);
          this.pageSize = size;
          this.showPage(Math.floor(first / size));
        }
      });
      this.observer.observe(this.grid);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    showPage(page) {
      const pages = Math.ceil(this.items.length / this.pageSize);
      this.page = Math.max(0, Math.min(page, pages - 1));
      this.items.forEach((item, index) => {
        item.hidden = index < this.page * this.pageSize || index >= (this.page + 1) * this.pageSize;
      });
      this.controls.hidden = pages < 2;
      this.status.textContent = 'Page ' + (this.page + 1) + ' of ' + pages;
      this.prev.disabled = this.page === 0;
      this.next.disabled = this.page === pages - 1;
    }
  });
}
